import { boot } from 'quasar/wrappers'
import Query from '/src/components/Query.vue'
import fldString from "/src/components/forms/fldString.vue"
import fldFloat from "/src/components/forms/fldFloat.vue"
import fldCheckbox from "/src/components/forms/fldCheckbox.vue"
import fldNumber from "/src/components/forms/fldNumber.vue"
import fldDateTime from "/src/components/forms/fldDateTime.vue"
import fldValueList from "/src/components/forms/fldValueList.vue"
import fldAutocomplete from "/src/components/forms/fldAutocomplete.vue"
import fldFile from "/src/components/forms/fldFile.vue"
import fldSubtype from "/src/components/forms/fldSubtype.vue"
import fldSignature from "/src/components/forms/fldSignature.vue"
import fldTicket from "/src/components/forms/fldTicket.vue"
import fldRichtext from "/src/components/forms/fldRichtext.vue"
import fldScript from "/src/components/forms/fldScript.vue"
import fldAddressGmapMeshup from "/src/components/forms/fldAddressGmapMeshup.vue"

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(({ app }) => {
  app.component("Query", Query)
  app.component("fldString", fldString)
  app.component("fldFloat", fldFloat)
  app.component("fldCheckbox", fldCheckbox)
  app.component("fldNumber", fldNumber)
  app.component("fldDateTime", fldDateTime)
  app.component("fldValueList", fldValueList)
  app.component("fldAutocomplete", fldAutocomplete)
  app.component("fldFile", fldFile)
  app.component("fldSubtype", fldSubtype)
  app.component("fldSignature", fldSignature)
  app.component("fldTicket", fldTicket)
  app.component("fldRichtext", fldRichtext)
  app.component("fldScript", fldScript)
  app.component("fldAddressGmapMeshup", fldAddressGmapMeshup)
})
